<div [hidden]="hidden">
  <app-title-bar></app-title-bar>

  <app-splash></app-splash>

  <div style="height: 60px"></div>

  <app-sdk-run></app-sdk-run>

</div>